// tslint:disable
export enum EnrollmentType {
    /**
     * @description If Membernumber type is Unknown
     */
    Unknown = 0,
    /**
     * @description Medical MemberNumber
     */
    Medical = 6,
    /**
     * @description Pharmacy MemberNumber
     */
    Pharmacy = 7,
}
(EnrollmentType as any)['UNKNOWN'] = 0;
(EnrollmentType as any)['MEDICAL'] = 6;
(EnrollmentType as any)['PHARMACY'] = 7;
